import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import * as XLSX from 'xlsx';

const Retenciones = () => {
  const [retenciones, setRetenciones] = useState([]);
  const [tipoFiltro, setTipoFiltro] = useState('todos');
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');

  useEffect(() => {
    const obtenerRetenciones = async () => {
      const snapshot = await getDocs(collection(db, 'retenciones'));
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data(), fecha: doc.data().fecha.toDate() }));
      setRetenciones(data);
    };
    obtenerRetenciones();
  }, []);

  const filtrarRetenciones = () => {
    return retenciones.filter(r => {
      const cumpleTipo = tipoFiltro === 'todos' || r.tipo === tipoFiltro;
      const dentroDeRango = (!fechaInicio || r.fecha >= new Date(fechaInicio)) &&
                            (!fechaFin || r.fecha <= new Date(fechaFin));
      return cumpleTipo && dentroDeRango;
    });
  };

  const exportarExcel = () => {
    const datos = filtrarRetenciones().map(r => ({
      Fecha: r.fecha.toLocaleDateString(),
      Tipo: r.tipo,
      Cliente_Proveedor: r.cliente || r.proveedor,
      RIF: r.rif,
      Monto: r.monto,
      Retencion: r.retencion,
      Total: r.total
    }));
    const ws = XLSX.utils.json_to_sheet(datos);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Retenciones');
    XLSX.writeFile(wb, 'Retenciones.xlsx');
  };

  return (
    <div className="reportes-container">
      <h2>Retenciones de IVA</h2>
      <div className="filtros-reportes">
        <label>Tipo:
          <select value={tipoFiltro} onChange={(e) => setTipoFiltro(e.target.value)}>
            <option value="todos">Todos</option>
            <option value="venta">Ventas</option>
            <option value="factura">Facturas por pagar</option>
          </select>
        </label>
        <input type="date" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
        <input type="date" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
        <button onClick={exportarExcel}>Exportar a Excel</button>
      </div>

      <ul className="facturas-lista">
        {filtrarRetenciones().map(r => (
          <li key={r.id} className="factura-item">
            <strong>{r.tipo.toUpperCase()}</strong><br />
            <strong>{r.cliente || r.proveedor}</strong> - {r.rif}<br />
            Fecha: {r.fecha.toLocaleDateString()}<br />
            Monto: ${r.monto.toFixed(2)}<br />
            Retención IVA: ${r.retencion.toFixed(2)}<br />
            Total Neto: ${r.total.toFixed(2)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Retenciones;
